/**
 * Strip HTML tags, decode common entities, normalise whitespace
 * so product descriptions render cleanly as plain text.
 */
const cleanDescription = (text: string) =>
  text
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'")
    .replace(/\\n/g, '\n')
    .replace(/\n{2,}/g, '\n')
    .split('\n')
    .map(line => line.trim())
    .join('\n')
    .trim();

export default cleanDescription;
